<template>
    <div id="header">
        <div class="wholeprogressbar"></div>
        <div class="newstapa-logo">
            <a
                href="https://newstapa.org/"
                target="_blank"
            >
                <newstapa-logo></newstapa-logo
            ></a>
        </div>
        <div class="h1-container">
            <h1 class="blackmountain-title">
                <router-link to="/">검은산: 2022년 울진 산불</router-link>
            </h1>
        </div>
        <div
            class="menu-trigger"
            @click="navTrigger"
        >
            <div class="menu-trigger__line"></div>
            <div class="menu-trigger__line"></div>
            <div class="menu-trigger__line"></div>
        </div>
        <div class="username">{{ this.role }} {{ this.username }}</div>
    </div>
</template>

<script>
import NewstapaLogo from './NewstapaLogo.vue';
export default {
    components: { NewstapaLogo },
    name: 'HeaderDiv',
    props: ['role', 'username'],
    methods: {
        navTrigger() {
            this.$emit('nav-trigger');
        },
    },
    mounted() {
        this.MultiLingual('.blackmountain-title');
    },
};
</script>
<style lang="scss" scoped>
#header {
    position: fixed;
    // background: $black;
    width: 100%;
    color: $white;
    padding: 15px 20px;
    display: grid;
    grid-template-columns: 70px 30px;
    align-items: center;
    justify-content: space-between;
    z-index: 9;
    background-color: black;
    background-position: center;
    .h1-container {
        font-weight: 400;
        font-size: 20px;
        text-align: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        display: flex;
        align-items: center;
        height: 100%;
    }
    .menu-trigger {
        display: grid;
        grid-template-columns: 1fr;
        align-items: center;
        height: 100%;
        cursor: pointer;
        &__line {
            height: 2px;
            background: $white;
        }
    }

    .newstapa-logo {
        height: 100%;
        a {
            width: 100%;
            display: flex;
        }
        svg {
            width: 100%;
            height: 100%;
            fill: $white;
        }
    }

    .blackmountain-title {
        line-height: 1;
    }

    .wholeprogressbar {
        position: fixed;
        top: 0;
        left: 0;
        height: 4px;
        background: $red;
        transition: width 0.2s;
    }

    .username {
        display: none;
        position: absolute;
        left: 10px;
        padding: 5px 20px;
        bottom: -42px;
        background: rgb(40, 40, 40);
        border: 1px solid rgb(173, 173, 173);
        color: rgb(173, 173, 173);
        font-size: 0.9em;
    }
}

@media all and (max-width: 800px) {
    #header {
        padding: 10px;
        display: flex;
        .newstapa-logo {
            width: 50px;
            position: relative;
            top: 1px;
            svg {
                width: 100%;
            }
        }
        .menu-trigger {
            width: 23px;
            height: 23px;
        }
        .h1-container {
            white-space: nowrap;
        }
        .blackmountain-title {
            position: static;
            transform: translate(0);
            text-align: center;
            font-size: 16px;
        }
    }
}
</style>
